// src/services/msalService.ts
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../config/authConfig";
import { teamsAuthService } from "./teamsService";

export const msalInstance = new PublicClientApplication(msalConfig);

let isInitialized = false;
let initializationPromise: Promise<void> | null = null;

/**
 * Initialize MSAL instance (only if not in Teams)
 */
export const initializeMsal = async (): Promise<void> => {
    // Check if running in Teams first
    const teamsContext = await teamsAuthService.initialize();

    if (teamsContext.isInTeams) {
        isInitialized = true;
        return Promise.resolve();
    }

    if (isInitialized) {
        return Promise.resolve();
    }

    if (initializationPromise) {
        return initializationPromise;
    }

    initializationPromise = msalInstance
        .initialize()
        .then(() => {
            const accounts = msalInstance.getAllAccounts();

            if (accounts.length > 0) {
                if (!msalInstance.getActiveAccount()) {
                    msalInstance.setActiveAccount(accounts[0]);
                }
            }

            isInitialized = true;
        })
        .catch((error) => {
            console.error("MSAL initialization failed:", error);
            initializationPromise = null;
            isInitialized = false;
            throw error;
        });

    return initializationPromise;
};

export const ensureMsalReady = async (): Promise<void> => {
    if (!isInitialized) {
        await initializeMsal();
    }
};
